import { CheckableGroupContext } from "./chunk-YG26ROD3.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/RadioSwatchGroup/RadioSwatchGroup.MoreButton.tsx
import { forwardRef, useCallback, useContext } from "react";
import clsx from "clsx";
import { jsxs } from "react/jsx-runtime";
var RadioSwatchGroupMoreButton = forwardRef((_a, ref) => {
  var _b = _a,
    {
      className,
      onClick
    } = _b,
    rest = __objRest(_b, ["className", "onClick"]);
  const {
    setIsExpanded,
    totalItems,
    maxItems
  } = useContext(CheckableGroupContext);
  const handleClick = useCallback(event => {
    setIsExpanded(true);
    onClick == null ? void 0 : onClick(event);
  }, [setIsExpanded, onClick]);
  return /* @__PURE__ */jsxs("button", __spreadProps(__spreadValues({}, rest), {
    ref,
    type: "button",
    onClick: handleClick,
    className: clsx("pd:radio-swatch-group__more-button", className),
    children: ["+", " ", totalItems - maxItems]
  }));
});
var RadioSwatchGroup_MoreButton_default = RadioSwatchGroupMoreButton;
export { RadioSwatchGroup_MoreButton_default };